<head>
  <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.4.0/css/all.min.css"
    integrity="sha512-iecdLmaskl7CVkqkXNQ/ZH/XLlvWZOJyj7Yy7tcenmpD1ypASozpmT/E0iPtmFIB46ZmdtAc9eNBvH0H/ZpiBw=="
    crossorigin="anonymous" referrerpolicy="no-referrer" />
</head>
<div class="row">
  <div class="col-md-5">
    <app-breadcrumb></app-breadcrumb>
  </div>
  <div class="col-md-7">
    <div class="d-flex gap-3 pull-right button-continer align-items-center">

      <div class="d-flex gap-3" *ngFor="let button of buttonLabels">
        <span class="button-continer" *ngIf="buttonLabels != ''">
          <button *ngIf="button != ''" class="addIconContiner text-white px-4 reload_text"
            (click)="dynamicButtonClick(button)">
            {{button}}
          </button>
        </span>
      </div>

      <button class="addIconContiner text-white px-4 reload_text d-flex align-items-center gap-2"
        [matMenuTriggerFor]="moreActionsMenu" #menuTrigger="matMenuTrigger">
        More <i class="fa" [ngClass]="menuTrigger.menuOpen ? 'fa-caret-up' : 'fa-caret-down'"></i>
      </button>

      <mat-menu #moreActionsMenu="matMenu" xPosition="before">

        <button mat-menu-item *ngIf="showObsoleteInMenu" (click)="dynamicButtonClick('Obsolete')">
          <i class="fa fa-trash" style="color: red; margin-right: 8px;"></i>
          <span>Obsolete</span>
        </button>

        <button mat-menu-item *ngIf="message.isAuditTrailUser && firstFieldsList.length"
          (click)="openAuditTrail('detail', firstFieldsList, 0)">
          <i class="fa-solid fa-clipboard" style="color: #005c8a; margin-right: 8px;"></i>
          <span>Audit Trail</span>
        </button>

        <button mat-menu-item (click)="openTag()">
          <img src="../../../assets/img/tags.png" width="18px" height="18px"
            style="margin-right: 10px; filter: invert(1) brightness(0);" alt="" />
          <span>Tag to Home</span>
        </button>
      </mat-menu>

      <div title="Excel Report" class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
        (click)="openReportPopupWarning('Excel')" (keydown.enter)="openReportPopupWarning('Excel')">
        <i class="fa fa-file-excel-o" style="font-size:18px;color:white"></i>
      </div>

      <div title="Pdf Report" class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
        (click)="openReportPopupWarning('Pdf')" (keydown.enter)="openReportPopupWarning('Pdf')">
        <i class="fa fa-file-pdf-o" style="font-size:18px;color:white"></i>
      </div>

      <button mat-stroked-button class="cancelButton" (click)="back()">
        Cancel
      </button>

    </div>
  </div>
  <div class="row" *ngIf="instructions !=null">
    <p style="text-align: right;margin-bottom:0px;"><i>{{instructions}}</i></p>
  </div>
</div>
<br>
<div class="page-loading-shade" *ngIf="isProcessing">
  <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
</div>
<div class="menu-container">
  <div class=" menu-row-container">
    <div class="col-md-9 gridName-container" style="margin-bottom: 6px;">
      <span class="gridName justify-content-start"
        [matTooltip]="formObj.formName?.length > 150 ? formObj.formName : ''">
        {{ formObj.formName?.length > 150
        ? (formObj.formName | slice:0:150) + '...'
        : formObj.formName }}
      </span>

    </div>
    <div class="col-md-3 gridName-container pull-right" style="margin-bottom: 6px;">
      <span class="pull-right gridName justify-content-end">
        <span [ngClass]="formObj.status == 'Inactive' ||
            formObj.status == 'Locked' ||
            formObj.status == 'Expired' ||
            formObj.status == 'Approval Rejected' ||
            formObj.status == 'Review Rejected' ||
            formObj.status.includes('Requested More Info.') ||
            formObj.status.includes('Expired') ||
            formObj.status.includes('Inactive') ||
            formObj.status == 'Obsoleted' ||
            formObj.status == 'Deleted' ? 'delete' : formObj.status == 'Open' ||
            formObj.status == 'Active' ? 'approve' : formObj.status == 'Draft' ||
            formObj.status == 'Pending Review' ||
            formObj.status == 'Pending Approval' ||
            formObj.status.includes('Inprogress') ||
            formObj.status == 'Pending Publish'  ? 'draft' :  formObj.status == 'Published' ||
            formObj.status.includes('Completed') ? 'closed' :''">{{ formObj.status }}</span>
      </span>
    </div>
  </div>
</div>
<div class="table-container">
  <div class="row">
    <div class="col-md-4" *ngFor="let field of firstFieldsList,let i=index;">
      <div class="row" style="margin-bottom:10px;">
        <div><label for="name">{{field.question}}</label><span *ngIf="field.isMandatory =='Y'"
            class="mandatory-symbol">*</span></div>
        <div
          *ngIf="field.fieldType =='Text Field' && field.fieldDatatype !='Date' && field.fieldDatatype !='Datetime' && field.fieldDatatype !='Number'">
          <input attr.id="field{{i}}" class="input-filed-continers" type="text" [(ngModel)]="field.fieldDefaultValue"
            [disabled]="field.isNotEditable || saveButtonForForm == false" [ngStyle]="{
            'min-width': field.fieldWidth == null ? '100%' : field.fieldWidth+'px' ,
            'max-width': field.fieldWidth == null ? '100%' : field.fieldWidth+'px',
            'max-height': field.fieldHeight == null ? '100%' : field.fieldHeight+'px'}">
          <i *ngIf="field.instructions!=null" style="font-size:11px;">{{field.instructions}}</i>
          <span class="field{{i}}-required-msg" style="display: block;color: red;"
            *ngIf="field.fieldDefaultValue == null && field.isMandatory =='Y'">
            Please enter an {{field.fieldName}}</span>
        </div>

        <!--auto fill -->
        <div *ngIf="field.fieldType =='Auto Fill' && field.fieldDatatype !='Date' && field.fieldDatatype !='Datetime'">
          <input attr.id="field{{i}}" class="input-filed-continers" type="text" [(ngModel)]="field.fieldDefaultValue"
            disabled [ngStyle]="{
            'min-width':  '90%' ,
            'max-width':'90%' ,
            'max-height': field.fieldHeight == null ? '100%' : field.fieldHeight+'px'}">
          <i [ngStyle]="{ color: field.fieldDefaultValue==null ? 'gray' : 'green' }"
            style="font-size:26px;margin-left: 5px;"
            *ngIf="field.fieldDefaultValue==null && field.autofillType=='INSERT' && saveButtonForForm && !field.isNotEditable "
            class="fa-solid fa-fill" (click)="autoFillFuction(field,i)" (keydown.enter)="autoFillFuction(field,i)"
            matTooltip="Auto Fill"></i>
          <i [ngStyle]="{ color: field.fieldDefaultValue==null ? 'gray' : 'green' }"
            style="font-size:26px;margin-left: 5px;"
            *ngIf="field.autofillType=='INSERT OR UPDATE' && !field.isNotEditable && saveButtonForForm"
            class="fa-solid fa-fill" (click)="autoFillFuction(field,i)" (keydown.enter)="autoFillFuction(field,i)"
            matTooltip="Auto Fill"></i>
          <i *ngIf="field.instructions!=null"
            style="font-size:11px;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{field.instructions}}</i>
        </div>
        <!--auto fill date-->
        <div *ngIf="field.fieldType == 'Auto Fill' && field.fieldDatatype == 'Date'" class="d-flex align-items-center"
          style="gap: 8px;">
          <input attr.id="field{{i}}" type="text" class="form-control data-picker-continer" bsDatepicker [bsConfig]="{
      dateInputFormat: (field.autofillFormulaDetail ? field.autofillFormulaDetail : 'YYYY-MM-DD'),
      showWeekNumbers: false,
      containerClass: 'theme-dark-blue',
      showTodayButton: false,
      todayPosition: 'center'
    }" [dateCustomClasses]="dateCustomClasses" [(ngModel)]="field.fieldDefaultValue" disabled [ngStyle]="{
      'min-width': '90%',
      'max-width': '90%',
      'max-height': field.fieldHeight == null ? '100%' : field.fieldHeight + 'px'
    }" />

          <!-- Auto Fill icon for INSERT -->
          <i [ngStyle]="{ color: field.fieldDefaultValue == null ? 'gray' : 'green' }"
            style="font-size: 26px; cursor: pointer;" *ngIf=" saveButtonForForm &&
      field.fieldDefaultValue == null &&
      field.autofillType == 'INSERT'" class="fa-solid fa-fill" (click)="autoFillFuctionSectionDate(field, i,'form')"
            (keydown.enter)="autoFillFuctionSectionDate(field, i,'form')" matTooltip="Auto Fill"></i>

          <!-- Auto Fill icon for INSERT OR UPDATE -->
          <i [ngStyle]="{ color: field.fieldDefaultValue == null ? 'gray' : 'green' }"
            style="font-size: 26px; cursor: pointer;" *ngIf="saveButtonForForm &&
      field.autofillType == 'INSERT OR UPDATE' " class=" fa-solid fa-fill"
            (click)="autoFillFuctionSectionDate(field, i,'form')"
            (keydown.enter)="autoFillFuctionSectionDate(field, i,'form')" matTooltip="Auto Fill"></i>

          <!-- Instruction text -->
          <i *ngIf="field.instructions != null" style="font-size: 11px;">
            &nbsp;&nbsp;{{ field.instructions }}
          </i>
        </div>
        <!--auto fill datetime-->
        <div *ngIf="field.fieldType == 'Auto Fill' && field.fieldDatatype == 'Datetime'"
          class="d-flex align-items-center" style="gap: 8px;">
          <input attr.id="field{{i}}" type="text" class="form-control data-picker-continer" bsDatepicker [bsConfig]="{
      dateInputFormat: field.autofillFormulaDetail=='DD-MMM-YYYY  HH24:MI:SS'
        ? 'DD-MMM-YYYY HH:mm:ss'
        : 'DD-MMM-YYYY HH:mm:ss',
      showWeekNumbers: false,
      withTimepicker: true,
      containerClass: 'theme-dark-blue',
      showTodayButton: false,
      todayPosition: 'center'
    }" [dateCustomClasses]="dateCustomClasses" [(ngModel)]="field.fieldDefaultValue" disabled [ngStyle]="{
      'min-width': '90%',
      'max-width': '90%',
      'max-height': field.fieldHeight == null ? '100%' : field.fieldHeight + 'px'
    }" />

          <i [ngStyle]="{ color: field.fieldDefaultValue == null ? 'gray' : 'green' }"
            style="font-size: 26px; cursor: pointer;" *ngIf="
      field.fieldDefaultValue == null && 
      saveButtonForForm && 
      field.autofillType == 'INSERT'" class="fa-solid fa-fill" (click)="autoFillFuctionSectionDate(field, i,'form')"
            (keydown.enter)="autoFillFuctionSectionDate(field, i,'form')" matTooltip="Auto Fill"></i>

          <i [ngStyle]="{ color: field.fieldDefaultValue == null ? 'gray' : 'green' }"
            style="font-size: 26px; cursor: pointer;" *ngIf="
      field.autofillType == 'INSERT OR UPDATE' && 
      saveButtonForForm && 
      !field.isNotEditable" class="fa-solid fa-fill" (click)="autoFillFuctionSectionDate(field, i,'form')"
            (keydown.enter)="autoFillFuctionSectionDate(field, i,'form')" matTooltip="Auto Fill"></i>

          <i *ngIf="field.instructions != null" style="font-size: 11px;">
            &nbsp;&nbsp;{{ field.instructions }}
          </i>
        </div>


        <div *ngIf="field.fieldType =='Text Field' && field.fieldDatatype =='Number'">
          <input attr.id="field{{i}}" class="input-filed-continers" type="number" min="0" step=".01"
            [(ngModel)]="field.fieldDefaultValue" [disabled]="field.isNotEditable || saveButtonForForm == false"
            [ngStyle]="{
            'min-width': field.fieldWidth == null ? '100%' : field.fieldWidth+'px' ,
            'max-width': field.fieldWidth == null ? '100%' : field.fieldWidth+'px',
            'max-height': field.fieldHeight == null ? '100%' : field.fieldHeight+'px'}">
          <i *ngIf="field.instructions!=null" style="font-size:11px;">{{field.instructions}}</i>
          <span class="field{{i}}-required-msg" style="display: block;color: red;"
            *ngIf="field.fieldDefaultValue == null && field.isMandatory =='Y'">
            Please enter an {{field.fieldName}}</span>
        </div>
        <div *ngIf="field.fieldType =='Auto Generated Number'">
          <input attr.id="field{{i}}" class="input-filed-continers" type="text" [(ngModel)]="field.fieldDefaultValue"
            disabled [ngStyle]="{
            'min-width': field.fieldWidth == null ? '100%' : field.fieldWidth+'px' ,
            'max-width': field.fieldWidth == null ? '100%' : field.fieldWidth+'px',
            'max-height': field.fieldHeight == null ? '100%' : field.fieldHeight+'px'}">
          <i *ngIf="field.instructions!=null" style="font-size:11px;">{{field.instructions}}</i>
          <i *ngIf="field.fieldDefaultValue==null" style="font-size:11px;">Note : {{field.question}} will be generated
            after saving the record.</i>
        </div>
        <div *ngIf="field.fieldType =='Text Field' && field.fieldDatatype =='Date'">
          <input attr.id="field{{i}}" type="text" class="form-control data-picker-continer" bsDatepicker
            [bsConfig]="datePickerConfiguration" [dateCustomClasses]="dateCustomClasses"
            [(ngModel)]="field.fieldDefaultValue" [disabled]="field.isNotEditable || saveButtonForForm == false"
            [ngStyle]="{
              'min-width': field.fieldWidth == null ? '100%' : field.fieldWidth+'px' ,
              'max-width': field.fieldWidth == null ? '100%' : field.fieldWidth+'px',
              'max-height': field.fieldHeight == null ? '100%' : field.fieldHeight+'px'}" [maxDate]="field.maxDate"
            [minDate]="field.minDate">
          <i *ngIf="field.instructions!=null" style="font-size:11px;">{{field.instructions}}</i>
          <span class="field{{i}}-required-msg" style="display: block;color: red;"
            *ngIf="field.fieldDefaultValue == null && field.isMandatory =='Y'">
            Please enter an {{field.fieldName}}</span>
        </div>
        <div *ngIf="field.fieldType =='Text Field' && field.fieldDatatype =='Datetime'">
          <input attr.id="field{{i}}" type="text" class="form-control data-picker-continer" bsDatepicker
            #datePicker="bsDatepicker" [bsConfig]="dateTimePickerConfiguration" [dateCustomClasses]="dateCustomClasses"
            [(ngModel)]="field.fieldDefaultValue" [disabled]="field.isNotEditable || saveButtonForForm == false"
            [ngStyle]="{
              'min-width': field.fieldWidth == null ? '100%' : field.fieldWidth+'px' ,
              'max-width': field.fieldWidth == null ? '100%' : field.fieldWidth+'px',
              'max-height': field.fieldHeight == null ? '100%' : field.fieldHeight+'px'}" [maxDate]="field.maxDate"
            [minDate]="field.minDate" (keydown)="false"
            (ngModelChange)="field.fieldDefaultValue!=null?onDateChange(datePicker):''">
          <i *ngIf="field.instructions!=null" style="font-size:11px;">{{field.instructions}}</i>
          <span class="field{{i}}-required-msg" style="display: block;color: red;"
            *ngIf="field.fieldDefaultValue == null && field.isMandatory =='Y'">
            Please enter an {{field.fieldName}}</span>
        </div>
        <div *ngIf="field.fieldType =='Large Text'">
          <textarea attr.id="field{{i}}" type="text" class="input-filed-textarea" rows="4"
            [(ngModel)]="field.fieldDefaultValue" [disabled]="field.isNotEditable || saveButtonForForm == false"
            [ngStyle]="{
              'min-width': field.fieldWidth == null ? '100%' : field.fieldWidth+'px' ,
              'max-width': field.fieldWidth == null ? '100%' : field.fieldWidth+'px',
              'max-height': field.fieldHeight == null ? '100%' : field.fieldHeight+'px'}"></textarea>
          <i *ngIf="field.instructions!=null" style="font-size:11px;">{{field.instructions}}</i>
          <span class="field{{i}}-required-msg" style="display: block;color: red;"
            *ngIf="field.fieldDefaultValue == null && field.isMandatory =='Y'">
            Please enter an {{field.fieldName}}</span>
        </div>
        <div *ngIf="field.fieldType =='Document Repository' && field.fieldDefaultValue != null">
          <span>
            <a href="" style="display: inline-block;"
              (click)="viewDocFromLink($event,field.fieldDefaultValue)">{{field.fieldDefaultValue}}
            </a><i *ngIf="canModifyDocument" class="fa fa-times" (click)="removeDocRep(field)"
              (keydown.enter)="removeDocRep(field)" style="color: red;margin-left: 8px;font-size: 18px;"></i>
          </span>
        </div>
        <div class="row row-search-container" style="margin-bottom: 1%; position: relative;"
          *ngIf="field.fieldType =='Document Repository' && field.fieldDefaultValue == null">
          <div class="search-input-container">
            <i class="fa fa-search search-icon"></i>
            <input attr.id="field{{i}}" class="input-filed-continers" type="text" [(ngModel)]="field.fieldDefaultValue"
              (click)="canModifyDocument ? searchDocumentFunction(field) : null"
              [disabled]="field.isNotEditable || !canModifyDocument" [ngStyle]="{
      'min-width': field.fieldWidth == null ? '100%' : field.fieldWidth+'px' ,
      'max-width': field.fieldWidth == null ? '100%' : field.fieldWidth+'px',
      'max-height': field.fieldHeight == null ? '100%' : field.fieldHeight+'px'}">
          </div>
          <i *ngIf="field.instructions!=null" style="font-size:11px;">{{field.instructions}}</i>
          <span class="field{{i}}-required-msg" style="display: block;color: red;"
            *ngIf="field.fieldDefaultValue == null && field.isMandatory =='Y'">
            Please enter an {{field.fieldName}}</span>
        </div>

        <div *ngIf="field.fieldType=='Multiselect Drop Down'">
          <mat-select matInput multiple placeholder="Select" #flexifieldValueSelected1
            [(ngModel)]="field.selectedFlexifieldValue" (closed)="flexifieldValueTxt=''"
            (click)="focusmethod('flexifieldValueSearch')" (keydown.enter)="focusmethod('flexifieldValueSearch')"
            [disabled]="field.isNotEditable">
            <input type="search" id="flexifieldValueSearch" class="dropdownsearchstyle" [(ngModel)]="flexifieldValueTxt"
              matInput placeholder="search">
            <div class="select-all">
              <mat-checkbox [(ngModel)]="flexifieldValueSelected"
                (change)="toggleAllSelection('flexifieldValueSelected')">Select All</mat-checkbox>
            </div>
            <mat-option *ngFor="let item1 of field.dropdowns| multiAssessmentSearchPipe :flexifieldValueTxt"
              [value]="item1.valueExp">
              {{ item1.displayExp }}
            </mat-option>
          </mat-select>
          <i *ngIf="field.instructions!=null" style="font-size:11px;">{{field.instructions}}</i>
          <span class="field{{i}}-required-msg" style="display: block;color: red;"
            *ngIf="(!field.selectedFlexifieldValue || field.selectedFlexifieldValue.length === 0)&& field.isMandatory =='Y'">
            Please enter an {{field.fieldName}}</span>
        </div>
       <div *ngIf="field.fieldType =='Drop Down'">
  <mat-select matInput placeholder="Select" [(ngModel)]="field.fieldDefaultValue"
    [compareWith]="compareDropdownValues"
    (closed)="fieldsSearchTxt=''" (click)="focusmethod('focusSearch')"
    (keydown.enter)="focusmethod('focusSearch')" [ngStyle]="{
    'min-width': field.fieldWidth == null ? '100%' : field.fieldWidth+'px' ,
    'max-width': field.fieldWidth == null ? '100%' : field.fieldWidth+'px',
    'max-height': field.fieldHeight == null ? '100%' : field.fieldHeight+'px'}"
    [disabled]="field.isNotEditable">
    
    <input type="search" attr.id="field{{i}}" class="dropdownsearchstyle" [(ngModel)]="fieldsSearchTxt" matInput
      placeholder="Search">
      
    <mat-option class="unselectStyle" [value]="null">Un-select</mat-option>
    
    <mat-option *ngFor="let item of field.dropdowns | assessmentSearch : fieldsSearchTxt" [value]="item.valueExp">
      {{ item.displayExp }}
    </mat-option>
    
  </mat-select>
  <i *ngIf="field.instructions!=null" style="font-size:11px;">{{field.instructions}}</i>
  <span class="field{{i}}-required-msg" style="display: block;color: red;"
    *ngIf="field.fieldDefaultValue == null && field.isMandatory =='Y'">
    Please enter an {{field.fieldName}}</span>
</div>

        <div *ngIf="field.fieldType =='Vertical Radio Button' || field.fieldType =='Horizontal Radio Button'">
          <mat-radio-group attr.id="field{{i}}" [(ngModel)]="field.fieldDefaultValue" [ngStyle]="field.fieldType =='Vertical Radio Button' ? { 'display': 'flex', 'flex-direction': 'column',
            'min-width': field.fieldWidth == null ? '100%' : field.fieldWidth+'px' ,
              'max-width': field.fieldWidth == null ? '100%' : field.fieldWidth+'px',
              'max-height': field.fieldHeight == null ? '100%' : field.fieldHeight+'px'} : {'display':'ruby',
              'min-width': field.fieldWidth == null ? '100%' : field.fieldWidth+'px' ,
              'max-width': field.fieldWidth == null ? '100%' : field.fieldWidth+'px',
              'max-height': field.fieldHeight == null ? '100%' : field.fieldHeight+'px'}
             ">
            <mat-radio-button *ngFor="let val of field.dropDownValues" [value]="val" color="primary"
              [disabled]="field.isNotEditable || saveButtonForForm == false">{{val}}</mat-radio-button>
          </mat-radio-group>
          <div><i *ngIf="field.instructions!=null" style="font-size:11px;">{{field.instructions}}</i>
            <span class="field{{i}}-required-msg" style="display: block;color: red;"
              *ngIf="field.fieldDefaultValue == null && field.isMandatory =='Y'">
              Please enter an {{field.fieldName}}</span>
          </div>
        </div>

        <div attr.id="field{{i}}"
          *ngIf="field.fieldType =='Vertical Checkbox Button' || field.fieldType =='Horizontal Checkbox Button'">
          <div [ngStyle]="field.fieldType =='Vertical Checkbox Button' ? { 'display': 'flex', 'flex-direction': 'column','min-width': field.fieldWidth == null ? '100%' : field.fieldWidth+'px' ,
          'max-width': field.fieldWidth == null ? '100%' : field.fieldWidth+'px',
          'max-height': field.fieldHeight == null ? '100%' : field.fieldHeight+'px' } : {'display':'ruby','min-width': field.fieldWidth == null ? '100%' : field.fieldWidth+'px' ,
        'max-width': field.fieldWidth == null ? '100%' : field.fieldWidth+'px',
        'max-height': field.fieldHeight == null ? '100%' : field.fieldHeight+'px'}
          ">
            <section *ngFor="let val of field.dropDownValues">
              <mat-checkbox (change)="checkBoxChecked(field,$event,val)"
                [disabled]="field.isNotEditable && saveButtonForForm == false"
                [checked]="field.checkedCheckBoxValue.indexOf(val) != -1">{{val}}</mat-checkbox>
            </section>
          </div>
          <div><i *ngIf="field.instructions!=null" style="font-size:11px;">{{field.instructions}}</i>
            <span class="field{{i}}-required-msg" style="display: block;color: red;"
  *ngIf="(!field.checkedCheckBoxValue || field.checkedCheckBoxValue.length === 0) && field.isMandatory =='Y'">
  Please enter an {{field.fieldName}}</span>
          </div>
        </div>

      </div>
      <br>

    </div>
  </div>
  <div class="button-continer" mat-dialog-actions *ngIf="saveButtonForForm && firstFieldsList.length > 0">
    <span class="button-continer">
      <button class="addIconContiner text-white px-4 reload_text" (click)="saveFormFunc()">
        Save
      </button>
    </span>
  </div>
</div>
<div class="row" *ngIf="IsViewTabs" style="width:100%;">
  <div class="col-md-12">
    <mat-tab-group selectedIndex="0" mat-stretch-tabs class="trainingtab mat-tab-container mat-elevation-z4"
      animationDuration="0ms" (selectedTabChange)="onTabChanged($event);" [(selectedIndex)]="selectedTabIndex">
      <mat-tab *ngFor="let section of sectionList,let i=index;" label="{{section.sectionName}}">
        <ng-template mat-tab-label>
          <span>{{section.sectionName}}</span>
        </ng-template>
        <div class="table-container">
          <div id="header-container" class="d-flex justify-content-end gap-3 mt-1 mb-3">
            <div class="">
              <div class="search-container">
                <input type="text" class="form-control search_input" style="font-size: 12px"
                  placeholder="Search here..." (input)="applyFilter2($event,section)" [(ngModel)]="searchValue" />
              </div>
            </div>

            <div class="">
              <div class="d-flex gap-2 action-buttons-container">
                <div *ngIf="saveButtonForForm"
                  class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
                  (click)="addSectionDataFunc(section)" (keydown.enter)="addSectionDataFunc(section)"
                  matTooltip="Add {{section.addRecordLabel}}">
                  <img src="../../../assets/img/cr_module/add_new.svg" width="18px" height="18px" alt="add new" />
                  <span class="reload_text text-white">Add New</span>
                </div>
                <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
                  (click)="openReport('Excel','overAll',section,0)"
                  (keydown.enter)="openReport('Excel','overAll',section,0)">
                  <i class="fa fa-file-excel-o" style="font-size:18px;color:white"></i>
                  <span class="reload_text text-white">Excel Report</span>
                </div>
                <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
                  (click)="openReport('Pdf','overAll',section,0)"
                  (keydown.enter)="openReport('Pdf','overAll',section,0)">
                  <i class="fa fa-file-pdf-o" style="font-size:18px;color:white"></i>
                  <span class="reload_text text-white">PDF Report</span>
                </div>
                <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
                  *ngIf="message.isAuditTrailUser" (click)="openAuditTrail('overAll',section,0)"
                  (keydown.enter)="openAuditTrail('overAll',section,0)">
                  <i class="fa-solid fa-clipboard" style="font-size:18px;color:white"></i>
                  <span class="reload_text text-white">Audit Trail</span>
                </div>
                <div class="reloadIconContiner d-flex gap-2 justify-content-center align-items-center"
                  matTooltip="Refresh Grid" (click)="refreshGrid(section)" (keydown.enter)="refreshGrid(section)">
                  <img src="../../../assets/img/cr_module/reload.svg" width="18px" height="18px" alt="reload" />
                  <span class="reload_text">Reload</span>
                </div>
              </div>
            </div>
          </div>

          <table class="dynamic-table-container documentTable">

            <th id="grid-header-container" *ngFor="let field of section.columnList; let ix = index;" [ngStyle]="{
                    'min-width': '200px' ,
                    'max-width': '300px',
                    'overflow': 'hidden',
                    'text-overflow': 'ellipsis',
                    'white-space': 'nowrap'}" class="sticky-dynamic-col1">
              <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-2">
                <span>{{field.fieldName}}</span>
                <div class="d-flex gap-2 align-items-center">
                  <div>
                    <img src="../../../assets/img/qms_img/sort.svg" width="9px" height="16px" alt="sort" />
                  </div>
                </div>
              </div>
            </th>
            <th *ngIf="section.verificationReqd == 'Y'" [ngStyle]="{'min-width': '220px' ,'max-width': '220px','overflow': 'hidden',
                'text-overflow': 'ellipsis','white-space': 'nowrap'}">
              <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-2">
                <span>Status</span>
                <div class="d-flex gap-2 align-items-center">
                  <div>
                    <img src="../../../assets/img/qms_img/sort.svg" width="9px" height="16px" alt="sort" />
                  </div>
                </div>
              </div>
            </th>
            <th *ngIf="section.verificationReqd == 'Y'" [ngStyle]="{'min-width': '220px' ,'max-width': '220px','overflow': 'hidden',
                'text-overflow': 'ellipsis','white-space': 'nowrap'}">
              <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-2">
                <span>Verification Requested On</span>
                <div class="d-flex gap-2 align-items-center">
                  <div>
                    <img src="../../../assets/img/qms_img/sort.svg" width="9px" height="16px" alt="sort" />
                  </div>
                </div>
              </div>
            </th>
            <th *ngIf="section.verificationReqd == 'Y'" [ngStyle]="{'min-width': '250px' ,'max-width': '250px','overflow': 'hidden',
                'text-overflow': 'ellipsis','white-space': 'nowrap'}">

              <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-2">
                <span>Verifier</span>
                <div class="d-flex gap-2 align-items-center">
                  <div>
                    <img src="../../../assets/img/qms_img/sort.svg" width="9px" height="16px" alt="sort" />
                  </div>
                </div>
              </div>
            </th>
            <th *ngIf="section.verificationReqd == 'Y'" [ngStyle]="{'min-width': '200px' ,'max-width': '200px','overflow': 'hidden',
                'text-overflow': 'ellipsis','white-space': 'nowrap'}">
              <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-2">
                <span>Verified On</span>
                <div class="d-flex gap-2 align-items-center">
                  <div>
                    <img src="../../../assets/img/qms_img/sort.svg" width="9px" height="16px" alt="sort" />
                  </div>
                </div>
              </div>
            </th>
            <th *ngIf="section.verificationReqd == 'Y'" [ngStyle]="{'min-width': '250px' ,'max-width': '250px','overflow': 'hidden',
                'text-overflow': 'ellipsis','white-space': 'nowrap'}">
              <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-2">
                <span>Verifier Comments</span>
                <div class="d-flex gap-2 align-items-center">
                  <div>
                    <img src="../../../assets/img/qms_img/sort.svg" width="9px" height="16px" alt="sort" />
                  </div>
                </div>
              </div>
            </th>

            <th *ngIf="section.withdrawalReqd == 'Y'" [ngStyle]="{'min-width': '220px' ,'max-width': '220px','overflow': 'hidden',
                'text-overflow': 'ellipsis','white-space': 'nowrap'}">
              <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-2">
                <span>Withdrawal Requested On</span>
                <div class="d-flex gap-2 align-items-center">
                  <div>
                    <img src="../../../assets/img/qms_img/sort.svg" width="9px" height="16px" alt="sort" />
                  </div>
                </div>
              </div>
            </th>
            <th *ngIf="section.withdrawalReqd == 'Y'" [ngStyle]="{'min-width': '250px' ,'max-width': '250px','overflow': 'hidden',
                'text-overflow': 'ellipsis','white-space': 'nowrap'}">

              <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-2">
                <span>Withdrawer</span>
                <div class="d-flex gap-2 align-items-center">
                  <div>
                    <img src="../../../assets/img/qms_img/sort.svg" width="9px" height="16px" alt="sort" />
                  </div>
                </div>
              </div>
            </th>
            <th *ngIf="section.withdrawalReqd == 'Y'" [ngStyle]="{'min-width': '200px' ,'max-width': '200px','overflow': 'hidden',
                'text-overflow': 'ellipsis','white-space': 'nowrap'}">
              <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-2">
                <span>Withdrawn Action Taken On</span>
                <div class="d-flex gap-2 align-items-center">
                  <div>
                    <img src="../../../assets/img/qms_img/sort.svg" width="9px" height="16px" alt="sort" />
                  </div>
                </div>
              </div>
            </th>
            <th *ngIf="section.withdrawalReqd == 'Y'" [ngStyle]="{'min-width': '250px' ,'max-width': '250px','overflow': 'hidden',
                'text-overflow': 'ellipsis','white-space': 'nowrap'}">
              <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-2">
                <span>Withdrawer Comments</span>
                <div class="d-flex gap-2 align-items-center">
                  <div>
                    <img src="../../../assets/img/qms_img/sort.svg" width="9px" height="16px" alt="sort" />
                  </div>
                </div>
              </div>
            </th>
            <th [ngStyle]="{'min-width': '250px' ,'max-width': '250px','overflow': 'hidden',
            'text-overflow': 'ellipsis','white-space': 'nowrap'}">
              <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-2">
                <span>Created On</span>
                <div class="d-flex gap-2 align-items-center">
                  <div>
                    <img src="../../../assets/img/qms_img/sort.svg" width="9px" height="16px" alt="sort" />
                  </div>
                </div>
              </div>
            </th>
            <th [ngStyle]="{'min-width': '250px' ,'max-width': '250px','overflow': 'hidden',
            'text-overflow': 'ellipsis','white-space': 'nowrap'}">
              <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-2">
                <span>Created By</span>
                <div class="d-flex gap-2 align-items-center">
                  <div>
                    <img src="../../../assets/img/qms_img/sort.svg" width="9px" height="16px" alt="sort" />
                  </div>
                </div>
              </div>
            </th>
            <th [ngStyle]="{'min-width': '250px' ,'max-width': '250px','overflow': 'hidden',
            'text-overflow': 'ellipsis','white-space': 'nowrap'}">
              <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-2">
                <span>Updated On</span>
                <div class="d-flex gap-2 align-items-center">
                  <div>
                    <img src="../../../assets/img/qms_img/sort.svg" width="9px" height="16px" alt="sort" />
                  </div>
                </div>
              </div>
            </th>
            <th [ngStyle]="{'min-width': '250px' ,'max-width': '250px','overflow': 'hidden',
            'text-overflow': 'ellipsis','white-space': 'nowrap'}">
              <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-2">
                <span>Updated By</span>
                <div class="d-flex gap-2 align-items-center">
                  <div>
                    <img src="../../../assets/img/qms_img/sort.svg" width="9px" height="16px" alt="sort" />
                  </div>
                </div>
              </div>
            </th>
            <th id="menu" class="sticky-col first-col"></th>
            <th class="sticky-col first-col menu"></th>
            <!-- search input row is added -->

            <!-- data row -->
            <tr *ngFor="let rowdata of section.dataList | searchFilter : searchValue ,let i=index;">
              <td *ngFor="let columnData of rowdata,let j=index;">
                <span
                  *ngIf="section.columnList[j].fieldType !== 'Document Repository' && (section.columnList[j].fieldDatatype === 'Char' || section.columnList[j].fieldDatatype === 'Number')">

                  {{columnData}}

                </span>
                <span
                  *ngIf="section.columnList[j].fieldType !== 'Document Repository' && (section.columnList[j].fieldDatatype !== 'Char' && section.columnList[j].fieldDatatype !== 'Number' && section.columnList[j].fieldDatatype!=='Date' && section.columnList[j].fieldDatatype!=='Datetime')">

                  {{columnData}}

                </span>
                <span
                  *ngIf="section.columnList[j].fieldType !== 'Document Repository' && (section.columnList[j].fieldDatatype=='Date' || section.columnList[j].fieldDatatype=='Datetime')">
                  <ng-container>
                    {{ columnData | date:getDateFormat(section.columnList[j].fieldDatatype) }}
                  </ng-container>
                </span>


                <span *ngIf="section.columnList[j].fieldType=='Document Repository'">
                  <a href="" style="display: inline-block;" (click)="viewDocFromLink($event,columnData)">{{columnData}}
                  </a>
                </span>
              </td>
              <td *ngIf="section.verificationReqd == 'Y'">{{section.rowList[i].status}}</td>
              <td *ngIf="section.verificationReqd == 'Y'">{{section.rowList[i].verificationRequestedOn
                |date : safeDateFormat | uppercase}}</td>
              <td *ngIf="section.verificationReqd == 'Y'">{{section.rowList[i].verifiedByUser}}</td>
              <td *ngIf="section.verificationReqd == 'Y'">{{section.rowList[i].verifiedOn |date : safeDateFormat |
                uppercase}}
              </td>
              <td *ngIf="section.verificationReqd == 'Y'">{{section.rowList[i].verifierComments}}</td>

              <td *ngIf="section.withdrawalReqd == 'Y'">{{section.rowList[i].withdrawalRequestedOn
                |date : safeDateFormat | uppercase}}</td>
              <td *ngIf="section.withdrawalReqd == 'Y'">{{section.rowList[i].withdrawnByUser}}</td>
              <td *ngIf="section.withdrawalReqd == 'Y'">{{section.rowList[i].withdrawOn |date : safeDateFormat |
                uppercase}}
              </td>
              <td *ngIf="section.withdrawalReqd == 'Y'">{{section.rowList[i].withdrawerComments}}</td>

              <td>{{section.rowList[i].createdOn|date : safeDateFormat | uppercase}}</td>
              <td>{{section.rowList[i].createdByUser}}</td>
              <td>{{section.rowList[i].updatedOn|date : safeDateFormat | uppercase}}</td>
              <td>{{section.rowList[i].updatedByUser}}</td>
              <td class="sticky-col first-col">
                <div class="action-icons">
                  <img alt="submit"
                    *ngIf="section.rowList[i].isShowVerifyButton && section.rowList[i].titleForSectionVerifyButton=='Submit for Verification' && section.verificationReqd == 'Y' && saveButtonForForm && formUserData.submitForVerification =='Y'"
                    src="../../../assets/img/Submit.svg" height="18" width="18"
                    matTooltip="{{section.rowList[i].titleForSectionVerifyButton}}" (click)="verifyDataFunc(section, rowdata)"
                    (keydown.enter)="verifyDataFunc(section, rowdata)">
                  <img alt="verify"
                    *ngIf="section.rowList[i].isShowVerifyButton && section.rowList[i].titleForSectionVerifyButton=='Verify' && section.verificationReqd == 'Y'"
                    src="../../../assets/img/Verify.svg" height="18" width="18"
                    matTooltip="{{section.rowList[i].titleForSectionVerifyButton}}" (click)="verifyDataFunc(section, rowdata)"
                    (keydown.enter)="verifyDataFunc(section, rowdata)">

                  <img alt="withdraw"
                    *ngIf="section.rowList[i].isShowWithdrawButton && section.rowList[i].titleForSectionWithdrawButton=='Submit for Withdrawal' && section.withdrawalReqd == 'Y' && saveButtonForForm && formUserData.submitForWithdraw =='Y' && section.rowList[i].status !='Withdrawal Rejected'"
                    src="../../../assets/img/Submit.svg" height="18" width="18"
                    matTooltip="{{section.rowList[i].titleForSectionWithdrawButton}}"
                    (click)="withdrawDataFunc(section, rowdata)" (keydown.enter)="withdrawDataFunc(section, rowdata)">
                  <img alt="withdraw"
                    *ngIf="section.rowList[i].isShowWithdrawButton && section.rowList[i].titleForSectionWithdrawButton=='Withdraw' && section.withdrawalReqd == 'Y' && section.rowList[i].status !='Withdrawal Rejected'"
                    src="../../../assets/img/Verify.svg" height="18" width="18"
                    matTooltip="{{section.rowList[i].titleForSectionWithdrawButton}}"
                    (click)="withdrawDataFunc(section, rowdata)" (keydown.enter)="withdrawDataFunc(section, rowdata)">
          <img *ngIf="message.showSwitchUser && (
      (section.rowList[i].status === 'Pending Verification' && section.verificationReqd === 'Y') ||
      (section.rowList[i].status === 'Pending Withdrawal'   && section.withdrawalReqd   === 'Y')
    )" src="../../../assets/img/user-switch.png" alt="Switch User" height="18" width="18" matTooltip="Switch User"
    style="margin-left: 5px; cursor: pointer;" 
    (click)="openSwitchVerifierPopup(section, rowdata)" 
    (keydown.enter)="openSwitchVerifierPopup(section, rowdata)" />

                  <i *ngIf="saveButtonForForm && section.rowList[i].status !='Verified' && section.rowList[i].status !='Withdrawal Rejected' && section.rowList[i].status !='Withdrawn' && section.rowList[i].status !='Withdrawer Requested More Info.' && section.rowList[i].status !='Pending Withdrawal' && section.rowList[i].status !='Pending Verification' && section.rowList[i].titleForSectionVerifyButton!='Submit for Withdrawal' && section.rowList[i].titleForSectionVerifyButton!='Withdraw' && section.rowList[i].titleForSectionVerifyButton!='Verify'"
                    class="fa-solid fa-pencil" matTooltip="Edit {{section.addRecordLabel}}"
                    (click)="editSectiondata(section, rowdata)" (keydown.enter)="editSectiondata(section, rowdata)"
                    style="margin-left: 5px;"></i>
                  <i *ngIf="saveButtonForForm && section.rowList[i].status !='Withdrawn' && section.rowList[i].status !='Withdrawal Rejected' && section.rowList[i].status !='Pending Withdrawal' && section.rowList[i].status !='Verified' && section.rowList[i].status !='Pending Verification' && section.rowList[i].titleForSectionVerifyButton!='Verify' && section.rowList[i].titleForSectionVerifyButton!='Submit for Withdrawal' && section.rowList[i].titleForSectionVerifyButton!='Withdraw'"
                    class="fa-sharp fa-solid fa-trash" matTooltip="Delete {{section.addRecordLabel}}"
                    (click)="deleteSectiondata(section, rowdata)" (keydown.enter)="deleteSectiondata(section, rowdata)"
                    style="margin-left: 5px;"></i>
                  <i class="fa-solid fa-clipboard" *ngIf="message.isAuditTrailUser" matTooltip="Audit Trail"
                    style="margin-left: 5px;" (click)="openAuditTrail('individual', section, rowdata)"
                    (keydown.enter)="openAuditTrail('individual', section, rowdata)"></i>
                </div>
              </td>
            </tr>
          </table>


        </div>
      </mat-tab>
      <mat-tab label="{{templateData.listOfStages}}" *ngIf="templateData.listOfStages != null">
        <ng-template mat-tab-label>
          <span><i class='fa-solid fa-file-circle-check' style="font-size: 26px;" aria-hidden="true"></i></span>&nbsp;
          <span>{{templateData.listOfStages}}</span>
        </ng-template>
        <app-stage-user [data]="formObj"></app-stage-user>
      </mat-tab>
    </mat-tab-group>
  </div>
</div>
<ng-template #confirmWithReasonPopup>
  <h2 mat-dialog-title>{{buttonLabel }}</h2>
  <div style="margin: 15px 15px;">
    <div>
      <div class="row">
        <div class="col-md-12">
          <div><label for="reason"> Reason</label><span class="mandatory-symbol">*</span></div>
          <textarea id="reason" rows="4" class="textarea-filed-continers" type="text" [(ngModel)]="reason"></textarea>
          <div id="reason-val-icon" class="field-icon-container"></div>
          <span id="reason-required-msg">Please enter reason</span>
        </div>
      </div>
      <br><br>
    </div>
    <div class="button-continer" mat-dialog-actions>
      <button mat-stroked-button class="addButton" (click)="confirmWithReasonFunc()">
        {{buttonLabel}}
      </button>
      <button mat-stroked-button class="cancelButton" (click)="cancelFunc()">
        <i class="fa fa-close"></i> Cancel
      </button>
    </div>
  </div>
</ng-template>
<ng-template #addAndEditPopup>
  <div class="ng-template-container">
    <div class="page-loading-shade" *ngIf="isProcessing">
      <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
    </div>
    <button class="close close-button" (click)="cancelAddAndEditFunction()" mat-button><i
        class="fa popupClose">&#xf00d;</i></button>
    <div mat-dialog-title>
      <label for="title" class="popupTitle"> {{sectionData.addRecordLabel}}</label>
      <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
    </div>
    <div class="form-continer">
      <div class="row text-center" *ngIf="sectionData.header != null">
        <h4>{{sectionData.header}}</h4>
      </div>
      <div class="row">
        <div class="col-md-{{12 / sectionData.fieldsPerLine | number}}"
          *ngFor="let field of sectionData.fieldsList,let i=index;">
          <div class="row" style="margin-bottom:10px;">
            <div><label for="name">{{field.question}}</label><span *ngIf="field.isMandatory =='Y'"
                class="mandatory-symbol">*</span></div>
            <div
              *ngIf="field.fieldType =='Text Field' && field.fieldDatatype !='Date' && field.fieldDatatype !='Datetime' && field.fieldDatatype !='Number'">
              <input attr.id="field{{i}}" class="input-filed-continers" type="text" [disabled]="field.isNotEditable"
                [(ngModel)]="field.fieldDefaultValue" [ngStyle]="{
                  'min-width': field.fieldWidth == null ? '100%' : field.fieldWidth+'px' ,
                  'max-width': field.fieldWidth == null ? '100%' : field.fieldWidth+'px',
                  'max-height': field.fieldHeight == null ? '100%' : field.fieldHeight+'px'}">
              <i *ngIf="field.instructions!=null" style="font-size:11px;">{{field.instructions}}</i>
              <span class="field{{i}}-required-msg" style="display: block;color: red;"
                *ngIf="field.fieldDefaultValue == null && field.isMandatory =='Y'">
                Please enter an {{field.fieldName}}</span>
            </div>

            <div
              *ngIf="field.fieldType =='Auto Fill' && field.fieldDatatype !='Date' && field.fieldDatatype !='Datetime'">
              <input attr.id="field{{i}}" class="input-filed-continers" type="text"
                [(ngModel)]="field.fieldDefaultValue" disabled [ngStyle]="{
                'min-width':field.autofillType=='INSERT' || field.autofillType=='INSERT OR UPDATE'?  '90%' :'100%',
                'max-width':field.autofillType=='INSERT' || field.autofillType=='INSERT OR UPDATE'?  '90%' :'100%' ,
                'max-height': field.fieldHeight == null ? '100%' : field.fieldHeight+'px'}">
              <i [ngStyle]="{ color: field.fieldDefaultValue==null ? 'gray' : 'green' }"
                style="font-size:26px;margin-left: 5px;"
                *ngIf="field.fieldDefaultValue==null && field.autofillType=='INSERT' && !field.isNotEditable"
                class="fa-solid fa-fill" (click)="autoFillFuctionSection(field,i)"
                (keydown.enter)="autoFillFuctionSection(field,i)" matTooltip="Auto Fill"></i>
              <i [ngStyle]="{ color: field.fieldDefaultValue==null ? 'gray' : 'green' }"
                style="font-size:26px;margin-left: 5px;"
                *ngIf="field.autofillType=='INSERT OR UPDATE' && !field.isNotEditable " class="fa-solid fa-fill"
                (click)="autoFillFuctionSection(field,i)" (keydown.enter)="autoFillFuctionSection(field,i)"
                matTooltip="Auto Fill"></i>
              <i *ngIf="field.instructions!=null"
                style="font-size:11px;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{field.instructions}}</i>
              <i *ngIf="field.fieldDefaultValue==null && field.autofillType=='SUBMIT FOR VERIFICATION'"
                style="font-size:11px;">Note : '{{field.question}}' will be generated
                after submit for verification.</i>

            </div>
            <div *ngIf="field.fieldType == 'Auto Fill' && field.fieldDatatype == 'Date'"
              class="d-flex align-items-center" style="gap: 8px;">
              <!-- Datepicker Input -->
              <input attr.id="field{{i}}" type="text" class="form-control data-picker-continer flex-grow-1" bsDatepicker
                [bsConfig]="{
      dateInputFormat: field.autofillFormulaDetail,
      showWeekNumbers: false,
      containerClass: 'theme-dark-blue',
      showTodayButton: false,
      todayPosition: 'center'
    }" [dateCustomClasses]="dateCustomClasses" [(ngModel)]="field.fieldDefaultValue" disabled [ngStyle]="{
      'max-height': field.fieldHeight == null ? '100%' : field.fieldHeight + 'px'
    }" />

              <!-- Auto Fill icon for INSERT -->
              <i [ngStyle]="{ color: field.fieldDefaultValue == null ? 'gray' : 'green' }"
                style="font-size: 26px; cursor: pointer;" *ngIf="
      field.fieldDefaultValue == null &&
      field.autofillType == 'INSERT' &&
      !field.isNotEditable" class="fa-solid fa-fill" (click)="autoFillFuctionSectionDate(field, i,'section')"
                (keydown.enter)="autoFillFuctionSectionDate(field, i,'section')" matTooltip="Auto Fill"></i>

              <!-- Auto Fill icon for INSERT OR UPDATE -->
              <i [ngStyle]="{ color: field.fieldDefaultValue == null ? 'gray' : 'green' }"
                style="font-size: 26px; cursor: pointer;" *ngIf="
      field.autofillType == 'INSERT OR UPDATE' &&
      !field.isNotEditable " class="fa-solid fa-fill" (click)="autoFillFuctionSectionDate(field, i,'section')"
                (keydown.enter)="autoFillFuctionSectionDate(field, i,'section')" matTooltip="Auto Fill"></i>

              <!-- Instructions -->
              <i *ngIf="field.instructions != null" style="font-size: 11px;">
                {{ field.instructions }}
              </i>

              <!-- Submit for Verification Note -->
              <i *ngIf="field.fieldDefaultValue == null && field.autofillType == 'SUBMIT FOR VERIFICATION'"
                style="font-size: 11px;">
                Note: '{{ field.question }}' will be generated after submit for verification.
              </i>
            </div>
            <div *ngIf="field.fieldType == 'Auto Fill' && field.fieldDatatype == 'Datetime'"
              class="d-flex align-items-center flex-wrap" style="gap: 8px;">
              <!-- Input with Datetime Picker -->
              <input attr.id="field{{i}}" type="text" class="form-control data-picker-continer flex-grow-1" bsDatepicker
                [bsConfig]="{
      dateInputFormat: field.autofillFormulaDetail == 'DD-MMM-YYYY  HH24:MI:SS'
        ? 'DD-MMM-YYYY HH:mm:ss'
        : 'DD-MMM-YYYY HH:mm:ss',
      showWeekNumbers: false,
      withTimepicker: true,
      containerClass: 'theme-dark-blue',
      showTodayButton: false,
      todayPosition: 'center'
    }" [dateCustomClasses]="dateCustomClasses" [(ngModel)]="field.fieldDefaultValue" disabled [ngStyle]="{
      'max-height': field.fieldHeight == null ? '100%' : field.fieldHeight + 'px'
    }" />

              <!-- Auto Fill icon for INSERT -->
              <i [ngStyle]="{ color: field.fieldDefaultValue == null ? 'gray' : 'green' }"
                style="font-size: 26px; cursor: pointer;" *ngIf="
      field.fieldDefaultValue == null &&
      field.autofillType == 'INSERT' &&
      !field.isNotEditable" class="fa-solid fa-fill" (click)="autoFillFuctionSectionDate(field, i,'section')"
                (keydown.enter)="autoFillFuctionSectionDate(field, i,'section')" matTooltip="Auto Fill"></i>

              <!-- Auto Fill icon for INSERT OR UPDATE -->
              <i [ngStyle]="{ color: field.fieldDefaultValue == null ? 'gray' : 'green' }"
                style="font-size: 26px; cursor: pointer;" *ngIf="
      field.autofillType == 'INSERT OR UPDATE' &&
      !field.isNotEditable " class="fa-solid fa-fill" (click)="autoFillFuctionSectionDate(field, i,'section')"
                (keydown.enter)="autoFillFuctionSectionDate(field, i,'section')" matTooltip="Auto Fill"></i>

              <!-- Instructions -->
              <i *ngIf="field.instructions != null" style="font-size: 11px;">
                {{ field.instructions }}
              </i>

              <!-- Note for Submit Verification -->
              <i *ngIf="field.fieldDefaultValue == null && field.autofillType == 'SUBMIT FOR VERIFICATION'"
                style="font-size: 11px;">
                Note: '{{ field.question }}' will be generated after submit for verification.
              </i>
            </div>
            <div *ngIf="field.fieldType =='Text Field' && field.fieldDatatype =='Number'">
              <input attr.id="field{{i}}" class="input-filed-continers" type="number" min="0" step=".01"
                [(ngModel)]="field.fieldDefaultValue" [disabled]="field.isNotEditable" [ngStyle]="{
                'min-width': field.fieldWidth == null ? '100%' : field.fieldWidth+'px' ,
                'max-width': field.fieldWidth == null ? '100%' : field.fieldWidth+'px',
                'max-height': field.fieldHeight == null ? '100%' : field.fieldHeight+'px'}">
              <i *ngIf="field.instructions!=null" style="font-size:11px;">{{field.instructions}}</i>
              <span class="field{{i}}-required-msg" style="display: block;color: red;"
                *ngIf="field.fieldDefaultValue == null && field.isMandatory =='Y'">
                Please enter an {{field.fieldName}}</span>
            </div>

            <div *ngIf="field.fieldType =='Text Field' && field.fieldDatatype =='Date'">
              <input attr.id="field{{i}}" type="text" class="form-control data-picker-continer" bsDatepicker
                [bsConfig]="datePickerConfiguration" [dateCustomClasses]="dateCustomClasses"
                [(ngModel)]="field.fieldDefaultValue" [disabled]="field.isNotEditable" [ngStyle]="{
                  'min-width': field.fieldWidth == null ? '100%' : field.fieldWidth+'px' ,
                  'max-width': field.fieldWidth == null ? '100%' : field.fieldWidth+'px',
                  'max-height': field.fieldHeight == null ? '100%' : field.fieldHeight+'px'}" [maxDate]="field.maxDate"
                [minDate]="field.minDate">
              <i *ngIf="field.instructions!=null" style="font-size:11px;">{{field.instructions}}</i>
              <span class="field{{i}}-required-msg" style="display: block;color: red;"
                *ngIf="field.fieldDefaultValue == null && field.isMandatory =='Y'">
                Please enter an {{field.fieldName}}</span>
            </div>

            <div *ngIf="field.fieldType =='Text Field' && field.fieldDatatype =='Datetime'">
              <input attr.id="field{{i}}" type="text" class="form-control data-picker-continer" bsDatepicker
                #datePicker="bsDatepicker" [bsConfig]="dateTimePickerConfiguration"
                [dateCustomClasses]="dateCustomClasses" [(ngModel)]="field.fieldDefaultValue"
                [disabled]="field.isNotEditable" [ngStyle]="{
                  'min-width': field.fieldWidth == null ? '100%' : field.fieldWidth+'px' ,
                  'max-width': field.fieldWidth == null ? '100%' : field.fieldWidth+'px',
                  'max-height': field.fieldHeight == null ? '100%' : field.fieldHeight+'px'}" [maxDate]="field.maxDate"
                [minDate]="field.minDate" (keydown)="false"
                (ngModelChange)="field.fieldDefaultValue!=null?onDateChange(datePicker):''">
              <i *ngIf="field.instructions!=null" style="font-size:11px;">{{field.instructions}}</i>
              <span class="field{{i}}-required-msg" style="display: block;color: red;"
                *ngIf="field.fieldDefaultValue == null && field.isMandatory =='Y'">
                Please enter an {{field.fieldName}}</span>
            </div>
            <div *ngIf="field.fieldType=='Multiselect Drop Down'">
              <mat-select matInput multiple placeholder="Select" #flexifieldValueSelected1
                [(ngModel)]="field.selectedFlexifieldValue" (closed)="flexifieldValueTxt=''"
                (click)="focusmethod('flexifieldValueSearch')" (keydown.enter)="focusmethod('flexifieldValueSearch')"
                [disabled]="field.isNotEditable">
                <input type="search" id="flexifieldSearch" class="dropdownsearchstyle" [(ngModel)]="flexifieldValueTxt"
                  matInput placeholder="search">
                <div class="select-all">
                  <mat-checkbox [(ngModel)]="flexifieldValueSelected"
                    (change)="toggleAllSelection('flexifieldValueSelected')">Select All</mat-checkbox>
                </div>
                <mat-option *ngFor="let item1 of field.dropdowns| multiAssessmentSearchPipe :flexifieldValueTxt"
                  [value]="item1.valueExp">
                  {{ item1.displayExp }}
                </mat-option>
              </mat-select>
              <i *ngIf="field.instructions!=null" style="font-size:11px;">{{field.instructions}}</i>
              <span class="field{{i}}-required-msg" style="display: block;color: red;"
  *ngIf="(!field.selectedFlexifieldValue || field.selectedFlexifieldValue.length === 0) && field.isMandatory =='Y'">
  Please enter an {{field.fieldName}}</span>
            </div>
            <div *ngIf="field.fieldType =='Auto Generated Number'">
              <input attr.id="field{{i}}" class="input-filed-continers" type="text"
                [(ngModel)]="field.fieldDefaultValue" disabled [ngStyle]="{
                'min-width': field.fieldWidth == null ? '100%' : field.fieldWidth+'px' ,
                'max-width': field.fieldWidth == null ? '100%' : field.fieldWidth+'px',
                'max-height': field.fieldHeight == null ? '100%' : field.fieldHeight+'px'}">
              <i *ngIf="field.instructions!=null" style="font-size:11px;">{{field.instructions}}</i>
              <i *ngIf="field.fieldDefaultValue==null" style="font-size:11px;">Note : {{field.question}} will be
                generated after saving the record.</i>
            </div>
            <div *ngIf="field.fieldType =='Large Text'">
              <textarea attr.id="field{{i}}" type="text" class="input-filed-textarea" rows="4"
                [(ngModel)]="field.fieldDefaultValue" [disabled]="field.isNotEditable" [ngStyle]="{
                  'min-width': field.fieldWidth == null ? '100%' : field.fieldWidth+'px' ,
                  'max-width': field.fieldWidth == null ? '100%' : field.fieldWidth+'px',
                  'max-height': field.fieldHeight == null ? '100%' : field.fieldHeight+'px'}"></textarea>
              <i *ngIf="field.instructions!=null" style="font-size:11px;">{{field.instructions}}</i>
              <span class="field{{i}}-required-msg" style="display: block;color: red;"
                *ngIf="field.fieldDefaultValue == null && field.isMandatory =='Y'">
                Please enter an {{field.fieldName}}</span>
            </div>
            <div *ngIf="field.fieldType =='Document Repository' && field.fieldDefaultValue != null">
              <span>
                <a href="" style="display: inline-block;"
                  (click)="viewDocFromLink($event,field.fieldDefaultValue)">{{field.fieldDefaultValue}}
                </a><i *ngIf="canModifyDocument" class="fa fa-times" (click)="removeDocRep(field)"
                  (keydown.enter)="removeDocRep(field)" style="color: red;margin-left: 8px;font-size: 18px;"></i>
              </span>
            </div>
            <div class="row row-search-container" style="margin-bottom: 1%; position: relative;"
              *ngIf="field.fieldType =='Document Repository' && field.fieldDefaultValue == null">
              <div class="search-input-container">
                <i class="fa fa-search search-icon"></i>
                <input attr.id="field{{i}}" class="input-filed-continers" type="text"
                  [(ngModel)]="field.fieldDefaultValue"
                  (click)="canModifyDocument ? searchDocumentFunction(field) : null"
                  [disabled]="field.isNotEditable || !canModifyDocument" [ngStyle]="{
                    'min-width': field.fieldWidth == null ? '100%' : field.fieldWidth+'px' ,
                    'max-width': field.fieldWidth == null ? '100%' : field.fieldWidth+'px',
                    'max-height': field.fieldHeight == null ? '100%' : field.fieldHeight+'px'}">
              </div>
              <i *ngIf="field.instructions!=null" style="font-size:11px;">{{field.instructions}}</i>
              <span class="field{{i}}-required-msg" style="display: block;color: red;"
                *ngIf="field.fieldDefaultValue == null && field.isMandatory =='Y'">
                Please enter an {{field.fieldName}}</span>
            </div>

          <div *ngIf="field.fieldType =='Drop Down'">
  <mat-select matInput placeholder="Select" [(ngModel)]="field.fieldDefaultValue"
    [compareWith]="compareDropdownValues"
    (closed)="fieldsSearchTxt=''" (click)="focusmethod('focusSearch')"
    (keydown.enter)="focusmethod('focusSearch')" [ngStyle]="{
    'min-width': field.fieldWidth == null ? '100%' : field.fieldWidth+'px' ,
    'max-width': field.fieldWidth == null ? '100%' : field.fieldWidth+'px',
    'max-height': field.fieldHeight == null ? '100%' : field.fieldHeight+'px'}"
    [disabled]="field.isNotEditable">
    
    <input type="search" attr.id="field{{i}}" class="dropdownsearchstyle" [(ngModel)]="fieldsSearchTxt" matInput
      placeholder="Search">
      
    <mat-option class="unselectStyle" [value]="null">Un-select</mat-option>
    
    <mat-option *ngFor="let item of field.dropdowns | assessmentSearch : fieldsSearchTxt" [value]="item.valueExp">
      {{ item.displayExp }}
    </mat-option>
    
  </mat-select>
  <i *ngIf="field.instructions!=null" style="font-size:11px;">{{field.instructions}}</i>
  <span class="field{{i}}-required-msg" style="display: block;color: red;"
    *ngIf="field.fieldDefaultValue == null && field.isMandatory =='Y'">
    Please enter an {{field.fieldName}}</span>
</div>
            <div *ngIf="field.fieldType =='Vertical Radio Button' || field.fieldType =='Horizontal Radio Button'">
              <mat-radio-group attr.id="field{{i}}" [(ngModel)]="field.fieldDefaultValue" [ngStyle]="field.fieldType =='Vertical Radio Button' ? { 'display': 'flex', 'flex-direction': 'column',
                'min-width': field.fieldWidth == null ? '100%' : field.fieldWidth+'px' ,
              'max-width': field.fieldWidth == null ? '100%' : field.fieldWidth+'px',
              'max-height': field.fieldHeight == null ? '100%' : field.fieldHeight+'px'} : {'display':'ruby',
              'min-width': field.fieldWidth == null ? '100%' : field.fieldWidth+'px' ,
              'max-width': field.fieldWidth == null ? '100%' : field.fieldWidth+'px',
              'max-height': field.fieldHeight == null ? '100%' : field.fieldHeight+'px'}
                 ">
                <mat-radio-button *ngFor="let val of field.dropDownValues" [value]="val"
                  [disabled]="field.isNotEditable">{{val}}</mat-radio-button>
              </mat-radio-group>
              <div><i *ngIf="field.instructions!=null" style="font-size:11px;">{{field.instructions}}</i>
                <span class="field{{i}}-required-msg" style="display: block;color: red;"
                  *ngIf="field.fieldDefaultValue == null && field.isMandatory =='Y'">
                  Please enter an {{field.fieldName}}</span>
              </div>
            </div>

            <div attr.id="field{{i}}"
              *ngIf="field.fieldType =='Vertical Checkbox Button' || field.fieldType =='Horizontal Checkbox Button'">
              <div [ngStyle]="field.fieldType =='Vertical Checkbox Button' ? { 'display': 'flex', 'flex-direction': 'column','min-width': field.fieldWidth == null ? '100%' : field.fieldWidth+'px' ,
                'max-width': field.fieldWidth == null ? '100%' : field.fieldWidth+'px',
                'max-height': field.fieldHeight == null ? '100%' : field.fieldHeight+'px' } : {'display':'ruby','min-width': field.fieldWidth == null ? '100%' : field.fieldWidth+'px' ,
              'max-width': field.fieldWidth == null ? '100%' : field.fieldWidth+'px',
              'max-height': field.fieldHeight == null ? '100%' : field.fieldHeight+'px'}
                ">
                <section *ngFor="let val of field.dropDownValues">
                  <mat-checkbox (change)="checkBoxChecked(field,$event,val)"
                    [checked]="field.checkedCheckBoxValue.indexOf(val) != -1"
                    [disabled]="field.isNotEditable">{{val}}</mat-checkbox>
                </section>
              </div>

              <div><i *ngIf="field.instructions!=null" style="font-size:11px;">{{field.instructions}}</i>
                <span class="field{{i}}-required-msg" style="display: block;color: red;"
  *ngIf="(!field.checkedCheckBoxValue || field.checkedCheckBoxValue.length === 0) && field.isMandatory =='Y'">
  Please enter an {{field.fieldName}}</span>
              </div>
            </div>

          </div>
          <br>
        </div>
      </div>
      <br>
      <div class="row text-center" *ngIf="sectionData.instructions != null">
        <i>{{sectionData.instructions}}</i>
      </div>
    </div>
  </div>
  <br>
  <div class="button-continer" mat-dialog-actions>
    <button mat-stroked-button class="addButton" (click)="addAndEditFunction(sectionData)" *ngIf="visibleAddButton">
      <i class="fas fa-plus"></i> Add
    </button>
    <button mat-stroked-button class="addButton" (click)="addAndEditFunction(sectionData)" *ngIf="visibleEditButton">
      <i class="fas fa-user-edit"></i> Update
    </button>
    <button mat-stroked-button class="cancelButton" (click)="cancelAddAndEditFunction()">
      <i class="fa fa-close"></i> Cancel
    </button>
  </div>
</ng-template>
<ng-template #deletePopup>
  <div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
  </div>
  <button class="close close-button" (click)="cancelDeleteFunction()" mat-button><i
      class="fa popupClose">&#xf00d;</i></button>
  <div mat-dialog-title>
    <label for="title" class="popupTitle"> {{ sectionData.sectionName }}</label>
    <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
  </div>
  <div style="margin: 15px 15px;">
    <div>
      <div class="row">
        <div class="col-md-12">
          <div><label for="email">Reason For Delete</label><span class="mandatory-symbol">*</span></div>
          <textarea id="deleteTextarea" type="text" class="input-filed-textarea" rows="4" cols="50" [(ngModel)]="reason"
            (focusout)="onFieldFocusout()"></textarea>
          <span id="deleteTextarea-required-msg">Please provide the reason for delete</span>
        </div>
      </div>
    </div>
    <div class="button-continer" mat-dialog-actions>
      <button mat-stroked-button class="deleteButton" (click)="deleteFunction()">
        <i class="fa fa-trash"></i> Delete
      </button>
      <button mat-stroked-button class="cancelButton" (click)="cancelDeleteFunction()">
        <i class="fa fa-close"></i> Cancel
      </button>
    </div>
  </div>
</ng-template>
<ng-template #confirmPopup>
  <h2 mat-dialog-title>{{buttonLabel }}</h2>
  <div style="margin: 15px 15px;">
    <div class="form-continer">
      <div class="row">
        <div class="col-md-12">
          Are you sure you want to {{buttonLabel}}?
        </div>
      </div>
      <br>
    </div>
    <div class="button-continer" mat-dialog-actions>
      <button mat-stroked-button class="addButton" (click)="confirmOkFunc()">
        {{buttonLabel}}
      </button>
      <button mat-stroked-button class="cancelButton" (click)="cancelConfirmFunc()">
        <i class="fa fa-close"></i> Cancel
      </button>
    </div>
  </div>
</ng-template>

<ng-template #confirmWithDataPopup>
  <div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
  </div>
  <button class="close close-button" (click)="cancelConfirmWithDataFunc()" mat-button><i
      class="fa popupClose">&#xf00d;</i></button>

  <div mat-dialog-title>
    <label for="title" class="popupTitle"> {{buttonLabel}}</label>
    <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
  </div>
  <div style="padding: 2%;">
    <div class="row">
      <div class="col-md-6" style="border-right: 1px solid black;">
        <div><label style="margin-left: 20%;font-weight: 600;" for="status">Action</label><span
            class="mandatory-symbol">*</span></div>
        <mat-radio-group id="status" class="tp-radio-group" [(ngModel)]="selectedStatus"
          style="display: flex;flex-direction: column;">
          <mat-radio-button class="tp-radio-button" *ngFor="let status of statusList" [value]="status.codelistCode"
            (change)="onStatusSelect(status.codelistCode)">
            {{status.codelistName}}
          </mat-radio-button>
        </mat-radio-group>
        <span style="margin-left: 10%;" id="status-required-msg">Please select status</span>
      </div>
      <div class="col-md-6" *ngIf="isEsignRequired" style="margin-top: 2%;">
        <div class="row" *ngIf="isEsignRequired">
          <div><label for="username ">User Name</label><span class="mandatory-symbol">*</span>
          </div>
          <div> <input id="username" style="height: 80% !important;" class="input-filed-continers" type="text"
              [(ngModel)]="userName" disabled>
          </div>
        </div>
        <div class="row" *ngIf="(isEsignRequired && !isAdenabled)">
          <div><label for="pass ">Password</label><span class="mandatory-symbol">*</span></div>
          <div> <input id="pass" style="height: 80% !important;" class="input-filed-continers"
              [type]="changetypeAddAndEditPassword ? 'password' : 'text'" [(ngModel)]="password" noCopyPaste>
            <span class="eyeicon-container eye-color" (click)="showPassword()" (keydown.enter)="showPassword()">
              <i
                [class]="changetypeAddAndEditPassword ? 'fas fa-eye-slash' : 'fa fa-fw fa-eye field-icon toggle-password'"></i>
            </span>
          </div>
          <span style="margin-left: 10%;" id="pass-required-msg">Please enter password</span>
        </div>
      </div>
    </div>
    <div class="row">
      <div><label for="comment">Comments</label></div>
      <div> <textarea rows="4" id="comment" class="textarea-filed-continers" type="text"
          [(ngModel)]="comments"></textarea>
      </div>
    </div>

    <div class="row">
      <div><label for="comment">Document</label></div>
      <div>
        <span *ngIf="!clearedOperationDoc && evidenceFile">
          <p style="display: inline-block;">{{ buttonOperationFile?.name }}</p><i class="fa fa-close"
            (click)="removeOperationDoc()" (keydown.enter)="removeOperationDoc()"
            style="color: red;margin-left: 8px;font-size: 18px;"></i>
        </span>
        <input *ngIf="clearedOperationDoc || !evidenceFile" type="file" class="file-input"
          (change)="onConfirmFileSelected($event)" #fileUpload>
      </div>
    </div>
  </div>
  <div class="button-continer" mat-dialog-actions>
    <button mat-stroked-button class="addButton" (click)="confirmWithDataFunc()">
      {{buttonLabel}}
    </button>
    <button mat-stroked-button class="cancelButton" (click)="cancelConfirmWithDataFunc()">
      <i class="fa fa-close"></i> Cancel
    </button>
  </div>
</ng-template>
<ng-template #verifyPopup>
  <div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
  </div>
  <button class="close close-button" (click)="cancelVerifyFunc()" mat-button><i
      class="fa popupClose">&#xf00d;</i></button>
  <div mat-dialog-title>
    <label for="title" class="popupTitle"> {{ titleForSectionVerifyButton }}</label>
    <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
  </div>
  <div style="margin: 15px 15px;">
    <div>
      <div class="row" [hidden]="titleForSectionVerifyButton=='Verify'" style="margin-bottom: 8%;">
        <div class="col-md-10">
          <div><label for="email">Verifier</label><span class="mandatory-symbol">*</span></div>
          <mat-select id="verifier" matInput placeholder="Select" [(ngModel)]="selectedVerifier"
            (closed)="verifierSearchText=''" (click)="focusSearch('focus-verifier-search')"
            (keydown.enter)="focusSearch('focus-verifier-search')" (focusout)="onFieldFocusout()">
            <input type="search" id="focus-verifier-search" class="dropdownsearchstyle" [(ngModel)]="verifierSearchText"
              matInput placeholder="search">
            <mat-option class="unselectStyle" [value]="null">Un-select</mat-option>
            <mat-option *ngFor="let item of verifierDropdown | assessmentSearch : verifierSearchText"
              [value]="item.valueExp">
              {{ item.displayExp }}
            </mat-option>
          </mat-select>
          <span id="verifier-required-msg">Please select the verifier</span>
        </div>
      </div>
      <div class="row" [hidden]="titleForSectionVerifyButton == 'Submit for Verification'">
        <div class="col-md-6" style="border-right: 1px solid black;">
          <div><label style="margin-left: 20%;font-weight: 600;" for="status">Action</label><span
              class="mandatory-symbol">*</span></div>
          <mat-radio-group id="verifierstatus" class="tp-radio-group" [(ngModel)]="selectedVerifierStatus"
            style="display: flex;flex-direction: column;">
            <mat-radio-button class="tp-radio-button" *ngFor="let status of verifierStatusList" [value]="status"
              (change)="onVerifierStatusSelect(status)">
              {{status}}
            </mat-radio-button>
          </mat-radio-group>
          <span style="margin-left: 10%;" id="verifierstatus-required-msg">Please select status</span>
        </div>
        <div class="col-md-6" style="margin-top: 2%;">
          <div class="row">
            <div><label for="username ">User Name</label><span class="mandatory-symbol">*</span>
            </div>
            <div> <input id="displayusername" style="height: 80% !important;" class="input-filed-continers" type="text"
                [(ngModel)]="displayUserName" disabled>
            </div>
          </div>
          <div class="row" *ngIf="!isAdenabled">
            <div><label for="pass ">Password</label><span class="mandatory-symbol">*</span></div>
            <div> <input id="passwordcss" style="height: 80% !important;" class="input-filed-continers"
                [type]="changetypeAddAndEditPassword ? 'password' : 'text'" [(ngModel)]="password" noCopyPaste>
              <span class="eyeicon-container eye-color" (click)="showPassword()" (keydown.enter)="showPassword()">
                <i
                  [class]="changetypeAddAndEditPassword ? 'fas fa-eye-slash' : 'fa fa-fw fa-eye field-icon toggle-password'"></i>
              </span>
            </div>
            <span style="margin-left: 10%;" id="passwordcss-required-msg">Please enter password</span>
          </div>
        </div>
      </div>
      <div class="row" [hidden]="titleForSectionVerifyButton == 'Submit for Verification'">
        <div class="col-md-12">
          <div><label for="email">Comments</label></div>
          <textarea id="comments" type="text" class="input-filed-textarea" rows="4" cols="50"
            [(ngModel)]="verifyComments"></textarea>
          <span id="verifyComments-required-msg">Please provide the comments</span>
        </div>
      </div>
    </div>
    <div class="button-continer" mat-dialog-actions>
      <button mat-stroked-button class="deleteButton" (click)="perfomrVerifyFunc()">
        {{titleForSectionVerifyButton}}
      </button>
      <button mat-stroked-button class="cancelButton" (click)="cancelVerifyFunc()">
        <i class="fa fa-close"></i> Cancel
      </button>
    </div>
  </div>
</ng-template>
<ng-template #searchDocument>
  <div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
  </div>
  <button class="close close-button" (click)="cancelSearchDocumentFunction()" mat-button><i
      class="fa popupClose">&#xf00d;</i></button>
  <div mat-dialog-title>
    <label for="title" class="popupTitle">Search Document</label>
    <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
  </div>
  <div id="filed-container" class="form-continer">
    <app-folder-stucture [data]="'DOCUMENTFORFORMSLOGS'"
      (valueChange)="changeInFolderStructureChild($event)"></app-folder-stucture>
  </div>
  <div class="button-continer" mat-dialog-actions>
    <button mat-stroked-button class="addButton" (click)="addDocumentFunction()">
      <i class="fas fa-check"></i> Add
    </button>
    <button mat-stroked-button class="cancelButton" (click)="cancelSearchDocumentFunction()">
      <i class="fa fa-close"></i> Cancel
    </button>
  </div>
</ng-template>

<ng-template #excelPdfPopup>
  <div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
  </div>
  <button class="close close-button" (click)="cancelReportPopup()" mat-button>
    <i class="fa popupClose">&#xf00d;</i>
  </button>
  <div mat-dialog-title>
    <label for="title" class="popupTitle"> {{ popupDataTitle.title }}</label>
    <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
  </div>
  <div style="margin: 15px 15px;" class="align-center">
    <label for="email" style="font-size: medium; font-weight: bold;">
      Do you want to generate {{ popupDataTitle.title }} ?</label>
  </div>
  <div class="row justify-content-md-center" *ngIf="!isForExcel">
    <div class="col-sm-4">
      <label for="radio">PDF Page Size</label>
    </div>
    <div class="col-sm-8">
      <mat-radio-group [(ngModel)]="selectedPdfPageSize">
        <mat-radio-button *ngFor="let data of pdfPageSizes"
          [value]="data.codelistCode">{{data.codelistName}}</mat-radio-button>
      </mat-radio-group>
    </div>
  </div>
  <div class="row justify-content-md-center" *ngIf="!isForExcel">
    <div class="col-sm-4">
      <label for="email">Report Logo</label>
    </div>
    <div class="col-sm-8">
      <mat-select matInput placeholder="Select" [(ngModel)]="selectedReportLogoValue" (closed)="pdfDetailSearchText=''"
        (click)="focusSearch('focus-Logo-search')" (keydown.enter)="focusSearch('focus-Logo-search')">
        <input type="search" id="focus-Logo-search" class="dropdownsearchstyle" [(ngModel)]="pdfDetailSearchText"
          matInput placeholder="search">
        <mat-option [value]="null" class="unselectStyle"
          (onSelectionChange)="onReportLogoValueSelect($event,null);">Un-select</mat-option>
        <mat-option *ngFor="let item of reportLogoDropdown | assessmentSearch : pdfDetailSearchText"
          (onSelectionChange)="onReportLogoValueSelect($event,item)" [value]="item.valueExp">
          {{ item.displayExp }}
        </mat-option>
      </mat-select>
    </div>
  </div>
  <div class="row justify-content-md-center" *ngIf="!isForExcel">
    <div class="col-sm-4">
      <label for="email">Is Save Report?</label>
    </div>
    <div class="col-sm-8">
      <mat-slide-toggle color="primary" name="reportEnabled" [(ngModel)]="isSaveReport">
        <ng-container *ngIf="isSaveReport; else noisSaveReport">
          <span class="active-inActive-container" style="color: rgb(43, 227, 43);">Yes</span>
        </ng-container>
        <ng-template #noisSaveReport>
          <span style="color: red;">No</span>
        </ng-template>
      </mat-slide-toggle>
    </div>
  </div>
  <div class="row justify-content-md-center" *ngIf="!isForExcel">
    <div class="col-sm-4">
      <label for="email">Is Template Required?</label>
    </div>
    <div class="col-sm-8">
      <mat-slide-toggle color="primary" name="reportEnabled" [(ngModel)]="isTemplateRequired">
        <ng-container *ngIf="isTemplateRequired; else noisTemplateRequired">
          <span class="active-inActive-container" style="color: rgb(43, 227, 43);">Yes</span>
        </ng-container>
        <ng-template #noisTemplateRequired>
          <span style="color: red;">No</span>
        </ng-template>
      </mat-slide-toggle>
    </div>
  </div>
  <div class="row justify-content-md-center" *ngIf="!isForExcel">
    <div class="col-sm-4">
      <label for="email">Is Review & Approve Required?</label>
    </div>
    <div class="col-sm-8">
      <mat-slide-toggle color="primary" name="reportEnabled" [(ngModel)]="isReviewApproveRequired">
        <ng-container *ngIf="isReviewApproveRequired; else noisReviewApproveRequired">
          <span class="active-inActive-container" style="color: rgb(43, 227, 43);">Yes</span>
        </ng-container>
        <ng-template #noisReviewApproveRequired>
          <span style="color: red;">No</span>
        </ng-template>
      </mat-slide-toggle>
    </div>
  </div>
  <div class="row justify-content-md-center" *ngIf="!isForExcel && isSaveReport">
    <div class="col-sm-4">
      <label for="email">Report Name</label><span class="mandatory-symbol">*</span>
    </div>
    <div class="col-sm-8">
      <input type="text" class="input-filed-continers" [(ngModel)]="reportName">
    </div>
  </div>
  <div class="button-continer btn-align" style="margin-top: 3%;" mat-dialog-actions>
    <button mat-stroked-button class="addButton" (click)="generateReport(isForExcel ? 'Excel' : 'Pdf')">
      <i class="fa fa-file-excel-o"></i> Generate
    </button>
    <button mat-stroked-button class="cancelButton" (click)="cancelReportPopup()">
      <i class="fa fa-close"></i> Cancel
    </button>
  </div>
</ng-template>
<ng-template #infoPopup>
  <div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
  </div>
  <button class="close close-button" (click)="okInfo()" mat-button>
    <i class="fa popupClose">&#xf00d;</i>
  </button>
  <div mat-dialog-title>
    <label for="title" class="popupTitle"> Warning</label>
    <label for="app-name" class="popupAppTitle">One<span style="color: gold">QMS</span>
    </label>
  </div>
  <div style="margin: 15px 15px">
    <div class="row">
      <div class="col-md-12">
        {{ warningMsg }}
      </div>
    </div>
    <div class="button-continer" mat-dialog-actions>
      <button mat-stroked-button class="addButton" (click)="okInfo()">
        OK
      </button>
    </div>
  </div>
</ng-template>
<ng-template #viewPopup>
  <div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
  </div>
  <button class="close close-button" (click)="cancelViewPopup()" mat-button><i
      class="fa popupClose">&#xf00d;</i></button>
  <div mat-dialog-title>
    <label for="title" class="popupTitle"> View </label>
    <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
  </div>
  <div style="margin: 15px 15px;">
    <web-viewer [data]="viewerData" (oneQmsListener)="onUserActivity()"></web-viewer>
  </div>
</ng-template>
<ng-template #switchUserPopup>
  <div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
  </div>
  <button class="close close-button" (click)="cancelSwitchUserFunc()" mat-button><i
      class="fa popupClose">&#xf00d;</i></button>

  <div mat-dialog-title>
    <label for="title" class="popupTitle"> {{buttonLabel}}</label>
    <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
  </div>
  <div style="padding: 2%;">
    <div class="row">
      <div class="col-md-12">
        <div><label for="email">User</label><span class="mandatory-symbol">*</span></div>
        <mat-select id="switchUser" matInput placeholder="Select" [(ngModel)]="switchedToUser"
          (closed)="switchUserSearchText=''" (click)="focusSearch('focus-switchUser-search')"
          (keydown.enter)="focusSearch('focus-switchUser-search')" (focusout)="onFieldFocusout()">
          <input type="search" id="focus-switchUser-search" class="dropdownsearchstyle"
            [(ngModel)]="switchUserSearchText" matInput placeholder="search">
          <mat-option class="unselectStyle" [value]="null">Un-select</mat-option>
          <mat-option *ngFor="let item of dropdownForSwitchUsers | assessmentSearch : switchUserSearchText"
            [value]="item.userId">
            {{ item.userName }}
          </mat-option>
        </mat-select>
        <span id="switchUser-required-msg">Please select the user</span>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <div><label for="email">Comments</label><span class="mandatory-symbol">*</span></div>
        <textarea id="commentsForSwitchUser" type="text" class="input-filed-textarea" rows="4" cols="50"
          [(ngModel)]="comments"></textarea>
        <span id="commentsForSwitchUser-required-msg">Please provide the comments</span>
      </div>
    </div>
  </div>
  <div class="button-continer" mat-dialog-actions>
    <button mat-stroked-button class="addButton" (click)="switchUserConfirmFunc()">
      {{buttonLabel}}
    </button>
    <button mat-stroked-button class="cancelButton" (click)="cancelSwitchUserFunc()">
      <i class="fa fa-close"></i> Cancel
    </button>
  </div>
</ng-template>
<ng-template #formUserPopup>
  <div class="ng-template-container">
    <div class="page-loading-shade" *ngIf="isProcessing">
      <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
    </div>
    <button class="close close-button" (click)="cancelFormUserFunction()" mat-button><i
        class="fa popupClose">&#xf00d;</i></button>
    <div mat-dialog-title>
      <label for="title" class="popupTitle"> Form User</label>
      <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
    </div>
    <app-form-template-users [data]="formObj"></app-form-template-users>
  </div>
</ng-template>

<ng-template #excelPdfPopupWarning>
  <div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
  </div>
  <button class="close close-button" (click)="cancelReportPopupWarning()" mat-button>
    <i class="fa popupClose">&#xf00d;</i>
  </button>
  <div mat-dialog-title>
    <label for="title" class="popupTitle"> Warning</label>
    <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
  </div>
  <div style="margin: 15px 15px;" class="align-center">
    <label for="email" *ngIf="reportOrNormal" style="font-size: medium; font-weight: bold;">
      Please click <b>'Save'</b> to generate the report along with the form section.</label>

    <label for="email" *ngIf="!reportOrNormal" style="font-size: medium; font-weight: bold;">
      Please <b>'Save'</b> the forms fields.</label>
  </div>
  <div class="button-continer btn-align" style="margin-top: 3%;" mat-dialog-actions>
    <button mat-stroked-button class="addButton" *ngIf="reportOrNormal"
      (click)="openReportPopup(isForExcel ? 'Excel' : 'Pdf')">
      <i class="fa fa-file-excel-o"></i> Generate
    </button>
    <button mat-stroked-button class="cancelButton" (click)="cancelReportPopupWarning()">
      <i class="fa fa-close"></i> Cancel
    </button>
  </div>
</ng-template>


<ng-template #withdrawPopup>
  <div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
  </div>
  <button class="close close-button" (click)="cancelWithdrawFunc()" mat-button><i
      class="fa popupClose">&#xf00d;</i></button>
  <div mat-dialog-title>
    <label for="title" class="popupTitle"> {{ titleForSectionWithdrawButton }}</label>
    <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
  </div>
  <div style="margin: 15px 15px;">
    <div>
      <div class="row" [hidden]="titleForSectionWithdrawButton=='Withdraw'" style="margin-bottom: 8%;">
        <div class="col-md-10">
          <div><label for="email">Withdrawer</label><span class="mandatory-symbol">*</span></div>
          <mat-select id="withdrawer" matInput placeholder="Select" [(ngModel)]="selectedWithdrawer"
            (closed)="withdrawerSearchText=''" (click)="focusSearch('focus-withdrawer-search')"
            (keydown.enter)="focusSearch('focus-withdrawer-search')" (focusout)="onFieldFocusout()">
            <input type="search" id="focus-withdrawer-search" class="dropdownsearchstyle"
              [(ngModel)]="withdrawerSearchText" matInput placeholder="search">
            <mat-option class="unselectStyle" [value]="null">Un-select</mat-option>
            <mat-option *ngFor="let item of withdrawDropdown | assessmentSearch : withdrawerSearchText"
              [value]="item.valueExp">
              {{ item.displayExp }}
            </mat-option>
          </mat-select>
          <span id="withdrawer-required-msg">Please select the withdrawer</span>
        </div>
      </div>
      <div class="row" [hidden]="titleForSectionWithdrawButton == 'Submit for Withdrawal'">
        <div class="col-md-6" style="border-right: 1px solid black;">
          <div><label style="margin-left: 20%;font-weight: 600;" for="status">Action</label><span
              class="mandatory-symbol">*</span></div>
          <mat-radio-group id="withdrawerstatus" class="tp-radio-group" [(ngModel)]="selectedWithdrawStatus"
            style="display: flex;flex-direction: column;">
            <mat-radio-button class="tp-radio-button" *ngFor="let status of withdrawStatusList" [value]="status"
              (change)="onWithdrawStatusSelect(status)">
              {{status}}
            </mat-radio-button>
          </mat-radio-group>
          <span style="margin-left: 10%;" id="withdrawerstatus-required-msg">Please select status</span>
        </div>
        <div class="col-md-6" style="margin-top: 2%;">
          <div class="row">
            <div><label for="username ">User Name</label><span class="mandatory-symbol">*</span>
            </div>
            <div> <input id="disusername" style="height: 80% !important;" class="input-filed-continers" type="text"
                [(ngModel)]="displayUserName" disabled>
            </div>
          </div>
          <div class="row" *ngIf="!isAdenabled">
            <div><label for="withdrawPassword">Password</label><span class="mandatory-symbol">*</span></div>
            <div> <input id="withdrawPassword" style="height: 80% !important;" class="input-filed-continers"
                [type]="changetypeAddAndEditPassword ? 'password' : 'text'" [(ngModel)]="password" noCopyPaste>
              <span class="eyeicon-container eye-color" (click)="showPassword()" (keydown.enter)="showPassword()">
                <i
                  [class]="changetypeAddAndEditPassword ? 'fas fa-eye-slash' : 'fa fa-fw fa-eye field-icon toggle-password'"></i>
              </span>
            </div>
            <span style="margin-left: 10%; display:none; color: red;" id="withdrawPassword-required-msg">Please enter
              password</span>
          </div>
        </div>
      </div>
      <div class="row" [hidden]="titleForSectionWithdrawButton == 'Submit for Withdrawal'">
        <div class="col-md-12">
          <div><label for="email">Comments</label></div>
          <textarea id="withdrawcomments" type="text" class="input-filed-textarea" rows="4" cols="50"
            [(ngModel)]="withdrawerComments"></textarea>
          <span id="verifyComments-required-msg">Please provide the comments</span>
        </div>
      </div>
    </div>
    <div class="button-continer" mat-dialog-actions>
      <button mat-stroked-button class="deleteButton" (click)="perfomrWithdrawFunc()">
        {{titleForSectionWithdrawButton}}
      </button>
      <button mat-stroked-button class="cancelButton" (click)="cancelWithdrawFunc()">
        <i class="fa fa-close"></i> Cancel
      </button>
    </div>
  </div>
</ng-template>

<app-static-audit-trail #auditTrailPopup></app-static-audit-trail>
<app-excel-pdf #excelPdfPopup [excelPdf]="excelPdf"></app-excel-pdf>
<app-homepagetag #tagRecordPopup (valueEmitter)="onTagChildValueEmitted()"></app-homepagetag>
<app-switchuser #switchUserChild (valueEmitter)="onSwitchUserLogSaved($event)" [forms]="switchVerifierRowData">
</app-switchuser>